import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _FixedAssetCatalog, _FixedAssetItemByChekedReport } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import { AccountEditor } from '../../../../../../editor/AccountEditor';
import { BasicButton } from '../../../../../../theme/Component/BasicButton';
import usePaginator from '../../../../../../theme/Component/usePaginator';
import { toast } from 'react-toastify';
import { SelectFixedAsset } from '../FixedAsset/SelectFixedAsset';
import { SelectStoreEditor } from '../../SelectStore.editor';
import { FixedStateConstants } from './FixedStateConstants';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const FixedAssetItemsCheckedReportEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_FixedAssetItemByChekedReport)
    const [IDAccount, setIDAccount] = useState<number>(null)
    const [storeID, setstoreID] = useState<number>(null)
    const [state, setState] = useState<number>(null)
    const [id, setID] = useState(null);
    const [idFixedAsset, setidFixedAsset] = useState<number>(null);
    const [prefix, setprefix] = useState<any>(null);
    const [accountid, setaccountid] = useState<number>(null);
    const [renderValue, setRenderValue] = useState<string>("");
    const [form, setform] = useState<any>({
        Name: null,
        asset: null,
        placa: null
    })
    const modal = useModal("Activos Fijos", MODAL_LG);
    const paginador = usePaginator();


    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDItem == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {

        instance.getFixedAssetItemsCheckedReport(form.asset, IDAccount, storeID, state, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    setLista(resp.List)

                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDItem', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        // { title: 'Línea/Grupo de Activos', property: 'FixedAssetLineName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Controlado', property: 'Checked', visible: true },
        { title: 'Cuentas de Orden', property: 'OrderAccountant', visible: true },
        { title: 'Causa de la Baja', property: 'ItemDownCauseName', visible: true },
        { title: 'Tiempo Depreciación', property: 'DepreciationTime', visible: true },
        { title: 'Tiempo Depreciación Fiscal', property: 'FiscalDepreciationTime', visible: true },
        { title: 'Adición NIIF', property: 'NiifAdditionValue', visible: true },
        { title: 'Adición Fiscal', property: 'FiscalAdditionValue', visible: true },
        { title: 'Dependencia', property: 'IDLnFunctionalID', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Unidad de Negocio', property: 'IDBusinessCore', visible: true },
        { title: 'Reconocimiento NIIF Inicial', property: 'NiifInitialValue', visible: true },
        { title: 'Valor Residual', property: 'ResidualValue', visible: true },
        { title: 'Usar Cuenta Servicio en Ops NIIF', property: 'UseBrandIDForAllOps', visible: true },
        { title: 'No depreciar ni amortizar', property: 'NotDepreciateOrAmortize', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Activo Fijo"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? renderValue}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <label>Activo Fijo</label>
                        <SelectFixedAsset render={form.Name} idSelector={form.asset} onChange={(e) => { setform({ ...form, "asset": e.IDFixedAsset, "Name": e.Description }) }} label=" " returnType="Object" />
                    </div>
                    <div className="col-md-4">
                        <AccountEditor label="Responsable" idAccount={IDAccount} onChange={(e: any) => { setIDAccount(e.IDAccount) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectStoreEditor label='Almacén/Bodega' idSelector={storeID} onChange={(e) => { setstoreID(e.IDStore) }} />
                    </div>
                    <div className="col-md-4">
                        <FixedStateConstants idSelector={state} onChange={(e) => { setState(e) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="" eventClick={getLista}>Buscar*</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDItem); modal.close(); }} pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}></BasicTable>
            </Modal>
        </>
    )
}